import styled from 'styled-components';
import constants from '../../../core/constants';

const Container = styled.div`
  background-color: var(--background-background-UTP);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  //   justify-content: center;
  //   align-items: center;

  .logoDef {
    margin: 16px 0 0 16px;
  }
  .logoDef img {
    height: 24px;
  }

  .illustrationDef {
    margin: 84px 79px 0px 79px;
    display: flex;
    justify-content: center;
    // flex-direction: column;
  }

  .textDef {
    margin: 44px 16px 0px 16px;
    text-align: center;
    font-size: 16px;
    color: var(--text-text02);
  }

  .textDef p.textBlack {
    font-weight: 900;
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 8px;
  }

  .textSubtitle {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #4f6168;
  }

  .buttonDef {
    margin-top: 24px;
    text-align: center;
  }
  .button.sc-cc-button {
    -webkit-appearance: initial;
    background-color: var(--interaction-primary);
    color: #ffffff;
  }
  .sc-cc-button:hover {
    background-color: #745ef6;
  }
  .sc-cc-button:focus {
    background-color: #4318cd;
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    .logoDef {
      margin: 40px 0 0 40px;
    }
    .logoDef img {
      height: 32px;
    }
    // .illustrationDef {
    //   margin: 158px 0px 0px 0px;
    // }
    // .textDef {
    //   text-align: center;
    //   margin: 0 auto;
    //   margin-top: 48px;
    //   // max-width: 480px;
    //   font-size: 24px;
    // }
    // .buttonDef {
    //   margin-top: 50px;
    //   text-align: center;
    // }
  }
`;

const ContainerNotEnrolled = styled.div`
  background-color: var(--background-background-UTP);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  padding: 0px 16px;
  align-items: center;
  justify-content: center;

  .logo {
    margin-bottom: 50px;
    align-items: left;
  }

  .button {
    min-width: 130px;
    min-height: 44px;
  }
`;

const ContainerInfo = styled.div.attrs((props: any) => ({
  isAdmin: props.isAdmin
}))`
  .textTitle {
    font-family: Lato;
    font-size: 20px;
    font-weight: 900;
    line-height: 32px;
    text-align: left;
    margin-bottom: 32px;
    color: var(--text-text02);
  }

  .column {
    display: block;
    div {
      margin-bottom: 16px;
    }
    @media (min-width: 786px) {
      display: ${(props) => (props.isAdmin ? 'block' : 'flex')};
      div {
        margin-right: 32px;
      }
    }
  }

  .textInfo {
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: var(--text-text02);

    span {
      display: flex;
      margin-bottom: 4px;
    }

    span img {
      margin-right: 8px;
    }

    p {
      margin-left: 26px;
    }
  }

  .link {
    font-size: 14px;
    text-underline-offset: 3px;
  }
`;

export { Container, ContainerNotEnrolled, ContainerInfo };
